<div class="row">
    <div class="col">
        <div class="blocks m-3 pt-0 px-0">

            
            <form [formGroup]="formBuilder">

                <!--main input-->
                <div class="row px-3">
                    <div class="col-6">
                        <div class="m-3">
                            <label for="field_name" class="form-label label-fw">Nome galleria*</label>
                            <input formControlName="name" name="name" type="text" [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}" class="form-control form-fw " id="field_name" placeholder="Nome galleria">
                            <div class="invalid-feedback" *ngIf="formControls.name.touched">
                                <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                                    Name is required
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="m-3">
                            <label for="seoId" class="form-label label-fw">SEO id</label>
                            <input formControlName="seoId" name="seoId" type="text" class="form-control form-fw " id="seoId"
                                placeholder="SEO id">
                        </div>
                    </div>
                </div>

                <!--Image-->
                <div class="row px-3 my-4 align-items-center">
                    <div class="col m-3">
                        <label for="exampleFormControlInput1" class="form-label label-fw">Anteprima</label><br>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3" (click)="openLoadImageFromPC()">
                            Carica da PC
                        </button>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3" (click)="openLoadImageFromDAM()">
                            Carica da  D.A.M.
                        </button>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3" (click)="deleteImage()">
                            Elimina
                        </button>

                        <div class="thumb-area d-flex justify-content-center my-3">
                            <div class="icona justify-content-center" [hidden]="visibleImageChoice">
                                <i class="fas fa-camera"></i>
                            </div>
                            <img [src]="imageChoice.url" alt="Anteprima" class="img-thumbnail img-thumbnail-dim" [hidden]="!visibleImageChoice">
                        </div>

                        <input type="text" formControlName="previewImage" name="previewImage" hidden>
                    </div>
                </div>
            </form>

            <!--Buttons-->
            <div class="row">
                <div class="col-12">
                    <div class="my-4 text-center">
                        <button type="button" [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false " class="btn btn-fw text me-3"  (click)="clickButtonSave()">Crea galleria</button>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text" (click)="clickButtonCancel()">Annulla</button>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>